import { render, staticRenderFns } from "./videolist.vue?vue&type=template&id=5e4e263c&scoped=true&"
import script from "./videolist.vue?vue&type=script&lang=js&"
export * from "./videolist.vue?vue&type=script&lang=js&"
import style0 from "./videolist.vue?vue&type=style&index=0&id=5e4e263c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e263c",
  null
  
)

export default component.exports